exports.env = 'PROD';
exports.advertiserAPIGatewayUrl = "https://www.delty.com/v1/advertisers";
exports.userMgmtAPIGatewayUrl = "https://www.delty.com/users";
exports.userLoginAPIGatewayUrl = 'https://www.delty.com/login';
exports.userLogoutAPIGatewayUrl = 'https://www.delty.com/logout';

exports.adminPortalUrl = 'http://www.delty.com/admin/#';
exports.advertiserPortalUrl = 'https://www.delty.com/advertiser/#';
exports.publisherPortalUrl = 'https://www.delty.com/publisher/#';
exports.webLoggerUrl = 'https://www.delty.com/v1/log';

var LogLevel = {
   none: 0,
   error: 1,
   warn: 2,
   info: 3,
   debug: 4
};
exports.frameworkLogLevel = LogLevel.warn;
exports.appLogLevel = LogLevel.warn;

exports.buttonReset = 3000;

exports.toggleFeatureGlobalExceptionHandler = true;
